<div
  *ngIf="hiddenModules"
>
  <app-header [userName]="userName"></app-header>

  <bc-menu class="menu-app-showcase" state="close" itemActive="id1">
    <bc-menu-drawer>
      <bc-menu-item
        [ngClass]="{ 'card-disabled': disabledMenuItem }"
        identifierContent="id1"
        text="Inicio"
        (click)="changePage('')"
        iconName="home"
        itemActive="true"
      ></bc-menu-item>
      <ng-container>
        <bc-menu-item
          [ngClass]="{ 'card-disabled': disabledMenuItem }"
          identifierContent="id2"
          text="Procesos y validaciones"
          iconName="layers"
          (click)="changePage(VALIDATIONS_PROCESS_MODULE)"
        ></bc-menu-item>
      </ng-container>

      <ng-container *ngIf="isAdminModules">
        <bc-menu-item
          [ngClass]="{ 'card-disabled': disabledMenuItem }"
          identifierContent="id3"
          (click)="changePage(ADMIN_MODULE_PARAM)"
          text="Administración"
          iconName="settings-2"
        ></bc-menu-item>
      </ng-container>

      <ng-container *ngIf="isAdminModules">
        <bc-menu-item
          [ngClass]="{ 'card-disabled': disabledMenuItem }"
          identifierContent="id4"
          (click)="changePage(REPORTS_MODULE)"
          text="Reportes"
          iconName="approving-user"
        ></bc-menu-item>
      </ng-container>
      <ng-container>
        <div class="log-out bc-menu-submenu btn-personalized">
          <div class="log-out-items bc-submenu-footer-container">
            <button class="log-out-btn bc-fab-button bc-fab-button-mini" (click)="logOut()">
              <bc-icon class="bc-icon bc-sm">quit</bc-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </bc-menu-drawer>

    <bc-menu-main></bc-menu-main>

    <div class="bc-content-body bcs-container-body">
      <div class="bc-content-router">
        <div class="bc-d-flex bc-justify-content-between bc-align-items-center bc-mb-3">
          <bc-breadcrumb-v2
            id="breadCrumbMaster"
            [breadcrumbItems]="breadcrumbItems"
          ></bc-breadcrumb-v2>
          <p class="m-0 status">{{ date }} {{ currentDateTime }}</p>
        </div>
        <router-outlet></router-outlet>
      </div>
      <app-footer></app-footer>
    </div>
  </bc-menu>

  <app-bcs-modal
    #modalRefreshToken
    title="Alerta"
    customWidth="medium"
    textBtnLeft="No"
    textBtn="Si"
    [outerCloseTap]="false"
    [hideCloseButton]="true"
    (stateClick)="checkTokenAction($event)"
  >
    <div class="bc-d-flex bc-justify-content-center bc-mb-4">
      <div class="countdown-spinner">
        <div class="spinner"></div>
        <div class="countdown-text">{{ countdownConfirmation }}</div>
      </div>
    </div>

    <span>{{ messageModalRefresh }}</span>
    <h6 class="bc-mt-2">¿Desea continuar?</h6>
  </app-bcs-modal>
</div>

<app-bcs-modal
  #modalErrorHelper
  customWidth="medium"
  title="Error de conexión"
  textBtn="Cerrar"
  typeIcon="error"
  [hideCloseButton]="true"
  [outerCloseTap]="false"
  [isCancellable]="false"
  (stateClick)="handleErrorRequestHelper($event)"
>
  <section class="bc-d-flex bc-justify-content-center bc-align-items-center">
    <p class="bcs-font-size-16px" [innerHTML]="errorMessage"></p>
  </section>
</app-bcs-modal>

<ng-container *ngIf="spinnerService.spinnerLoader | async">
  <section class="loader-spinner">
    <div class="bcs-spinner-container">
      <bc-loader speedLoader="0.5" sizeLoader="xl"></bc-loader>
    </div>

    <br />
    <p class="bc-mb-5 bcs-font-size-16px bc-text-center">{{ spinnerService.loaderMessage | async }}</p>
  </section>
</ng-container>
